/* eslint-disable no-unused-expressions */
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './training.module.scss';

const Language = (props) => {
  const { handelLanguage, selectedLanguage, handelNext, languages, category } = props;

  useEffect(() => {
    if (languages?.length === 1) {
      handelLanguage(languages?.[0]?.toLowerCase());
      handelNext('category', 'category');
    } else if (category) {
      handelLanguage(selectedLanguage);
      handelNext('category', 'category');
    }
  }, [languages, handelNext, handelLanguage, category, selectedLanguage]);

  return (
    <div className={styles.mdContainer}>
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          pointerEvents: 'none'
        }}
      />
      {languages?.length > 1 ? (
          <div class="modal-dialog" role="document" style={{ top: '30%' }}>
            <div class="modal-content p-2 py-4 border text-center ">
              <h4 className="">Please Choose Your Language</h4>
              <div className="d-flex justify-content-center">
                <div className="mt-4">
                  {languages?.map(ele => (
                    <div className="d-flex align-items-baseline mr-3" key={ele.id}>
                      <input
                        type="radio"
                        className="mx-2"
                        name="language"
                        checked={selectedLanguage === ele.toLowerCase()}
                        onClick={() => {
                          handelLanguage(ele.toLowerCase());
                        }}
                      />
                      <p>{`${ele.slice(0, 1).toUpperCase()}${ele.slice(1)}`}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-primary mt-4 w-25 "
                  onClick={() => {
                    selectedLanguage && handelNext('category', 'category');
                  }}
                >
                  <FormattedMessage id="inspections.new.next" defaultMessage="Next" />
                </button>
              </div>
            </div>
          </div>
      ) : (
        ''
      )}
    </div>
  );
};
export default Language;
